import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';
import { Roles } from './roles';

const RolesUserRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Roles />} />
    <Route path=":id"></Route>
  </ErrorBoundaryRoutes>
);

export default RolesUserRoutes;
